import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import WebFont from "webfontloader";
import { GlobalStyle } from "./styled";
import "tippy.js/dist/tippy.css";
WebFont.load({
    google: {
        families: [
            "Golos Text:400,500,600,700",
        ],
    },
});
export const InjectGlobalStyles = ({ children }) => {
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), children] }));
};
